import React from 'react';
import { Navigate } from 'react-router-dom';
import { SubscriptionFlowContainer, useBundlingEnabled } from '@features/subscriptions';
import { Box } from '@mui/material';

import { Lockout } from '../components/Lockout';

interface LockedOutContentProps {
  paymentStatus: string;
  userEmail: string;
  isExcepted: boolean;
  children: React.ReactNode;
}

/**
 * Component that handles locked_out user content rendering.
 * This component is rendered inside StatsigUserGate, ensuring that
 * useFeatureGate is called after user sync completes.
 */
export const LockedOutContent: React.FC<LockedOutContentProps> = ({
  paymentStatus,
  userEmail,
  isExcepted,
  children,
}) => {
  // Backend-driven check: bundling enabled if catalog contains add-ons
  const { isBundlingEnabled: hasBundlingFeature } = useBundlingEnabled();

  if (isExcepted) {
    return <>{children}</>;
  }

  if (paymentStatus === 'unpaid' && hasBundlingFeature) {
    // Unpaid status with feature flag: redirect to subscriptions page
    return <Navigate to="/practice/subscriptions" replace />;
  }

  if (paymentStatus === 'paused' && hasBundlingFeature) {
    // Paused status with feature flag: show new subscription flow without width constraints
    return <SubscriptionFlowContainer />;
  }

  // Other lockout statuses or paused without feature flag: show Lockout component with width constraints
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
      <Box sx={{ width: '70%' }}>
        <Lockout user_email={userEmail} payment_status={paymentStatus} />
      </Box>
    </Box>
  );
};
